<template>
  <div class="flex flex-row flex-wrap flex-grow mt-2 font-display" v-if="order">
    <div class="w-full p-0 text-gray-700">
      <h1 class="text-4xl font-bold">Visualizando pedido</h1>
      <small>
        <router-link :to="{ name: 'orders.index' }" exact>
          <span class="material-icons align-middle">
            keyboard_backspace
          </span>
          Visualizar todos
        </router-link>
      </small>
      <div class="flex flex-wrap mt-3 mb-2">
        <div class="w-full lg:w-3/6 p-2 ">
          <h2 class=" font-bold uppercase">
            COD. transação:
            <span class="block font-normal">#{{ $route.params.id }}</span>
          </h2>
        </div>
        <div class="w-full lg:w-1/6 p-2 ">
          Data do pedido:
          <span class="block text-sm font-bold">
            {{ order.created_at | moment('DD/MM/YYYY HH:mm') }}</span
          >
        </div>
        <div class="w-full lg:w-1/6 p-2 ">
          Método de pagamento:
          <span class="block text-sm font-bold">
            {{ order.store_payment_method.name }}</span
          >
        </div>
        <div class="w-full lg:w-1/6 p-2 ">
          Total do Pedido:
          <span class="block text-sm font-bold">
            {{ order.total_price | toCurrency }}</span
          >
        </div>
        <div class="w-full lg:w-2/4 mt-5 px-2 ">
          <div class="shadow-2l bg-white rounded-lg p-5 h-full">
            <h3 class="font-bold mb-3">Cliente</h3>
            <div class="w-full">
              <span class="block ">{{ order.customer_name }}</span>
              <span class="block ">{{ order.customer_cpf }}</span>
              <span class="block ">{{ order.customer_email }}</span>
              <span class="block ">{{ order.customer_phone }}</span>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-2/4 mt-5 px-2 ">
          <div class="shadow-2l bg-white rounded-lg p-5 h-full">
            <h3 class="font-bold mb-3">Status</h3>
            <select
              v-model="order_status_id"
              name="status"
              id="order_status"
              class="border block md:w-auto py-4 px-6 rounded bg-white focus:border-indigo-500 focus:shadow-focus focus:outline-none"
              @change="updateStatusOrder"
            >
              <option :value="item.id" v-for="item in statuses" :key="item.id">
                {{ item.name }}
              </option>
            </select>
            <small class="text-gray-500 mt-8"
              >Status relacionado ao pedido</small
            >
          </div>
        </div>
        <div class="w-full lg:w-4/4 mt-5 px-2 ">
          <div class="shadow-2l bg-white rounded-lg p-5 h-full">
            <h3 class="font-bold mb-3">Resumo do Pedido</h3>
            <div class="w-full overflow-x-auto">
              <table class="text-left w-full table-responsive ">
                <thead class="">
                  <tr>
                    <th
                      class="w-1/4 py-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                    >
                      Nome
                    </th>
                    <th
                      class="w-1/4 py-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                    >
                      Preço
                    </th>
                    <th
                      class="w-1/4 py-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                    >
                      Quantidade
                    </th>
                    <th
                      class="w-1/4 py-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="orderItem in order.order_item" :key="orderItem.id">
                    <td
                      class="border-dashed border-t border-gray-200 py-2 text-sm"
                    >
                      {{ orderItem.product.name }}
                      <div class="span" v-if="orderItem.variation_option.length > 0">
                        <div
                          class="text-xs text-gray-600"
                          v-for="option in orderItem.variation_option"
                          :key="option.id"
                        >
                        {{ `${option.variation.name} - ${option.value}` }}
                        </div>
                      </div>
                    </td>
                    <td
                      class="border-dashed border-t border-gray-200 py-2 text-sm"
                    >
                      {{ orderItem.price | toCurrency }}
                    </td>
                    <td
                      class="border-dashed border-t border-gray-200 py-2 text-sm"
                    >
                      {{ orderItem.quantity }}
                    </td>
                    <td
                      class="border-dashed border-t border-gray-200 py-2 text-sm"
                    >
                      {{ (orderItem.price * orderItem.quantity) | toCurrency }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})
// @ is an alias to /src
export default {
  name: '',
  components: {},
  data() {
    return {
      order: null,
      statuses: null,
      order_status_id: null
    }
  },
  computed: {},
  mounted() {
    this.$store.dispatch('SHOW_ORDER', this.$route.params.id).then(response => {
      this.order = response.data.order
      this.statuses = response.data.statuses
      this.order_status_id = response.data.order.order_status_id
    })
  },
  methods: {
    updateStatusOrder(event) {
      const data = {
        id: this.$route.params.id,
        order_status_id: this.order_status_id
      }
      this.$store.dispatch('UPDATE_ORDER', data).then(response => {
        this.$toasted.show(response.data.message, {
          position: 'bottom-center',
          duration: 5000,
          icon: 'check'
        })
      })
    }
  }
}
</script>
